import {
  useLocationHash,
  useLocationPathname,
  useLocationSearch,
  useNavigate,
} from '@rocketlane/rocket-router';
import { useEffect, useState } from 'react';
import { useTranslate } from 'hooks/use-translation';
import {
  getLoginSsoCallbackErrorMessage,
  SSO_LOGIN_ERROR_QUERY_PARAM,
} from './login-sso-callback-error';

/**
 * Reads `sso_error` from the login URL (set by backend redirect after Google SSO failure),
 * shows a message once, then strips the param from the address bar.
 */
export function useLoginSsoCallbackError(): string | null {
  const pathname = useLocationPathname();
  const searchStr = useLocationSearch();
  const hash = useLocationHash();
  const navigate = useNavigate();
  const translate = useTranslate();
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(searchStr);
    const code = params.get(SSO_LOGIN_ERROR_QUERY_PARAM);

    if (!code) {
      return;
    }

    setMessage(getLoginSsoCallbackErrorMessage(code, translate));
    params.delete(SSO_LOGIN_ERROR_QUERY_PARAM);
    const nextSearch = params.toString();

    navigate(
      {
        pathname,
        search: nextSearch ? `?${nextSearch}` : '',
        hash,
      },
      { replace: true },
    );
  }, [hash, pathname, searchStr, navigate, translate]);

  return message;
}
